import React from "react";
import type { FeatureDeepDiveBlock } from "@/types/product";
import { sanitizeHtml } from "@/utils/sanitizeHtml";
import shared from "../ProductDetailContent.module.css";
import styles from "./FeatureDeepDiveSection.module.css";

function BulletCheck() {
  return (
    <svg
      className={styles.bulletCheck}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="m5 12 5 5 10-10" />
    </svg>
  );
}

export const FeatureDeepDiveSection: React.FC<{
  block: FeatureDeepDiveBlock;
}> = ({ block }) => {
  const hasImage = Boolean(block.image?.url);
  const isReverse = hasImage && block.imagePosition === "right";
  const bullets = block.bulletPoints ?? [];
  const hasStat = Boolean(block.statBig && block.statLabel);

  return (
    <section
      className={`${shared.section} ${shared.bgVeryDark} ${styles.section}`}
    >
      <div
        className={`${shared.inner} ${styles.grid} ${hasImage ? "" : styles.noMedia} ${isReverse ? styles.reverse : ""}`}
      >
        {hasImage && (
          <div
            className={styles.media}
            style={{
              backgroundImage: `url('${block.image!.url.replace(/'/g, "%27")}')`,
            }}
          >
            {hasStat && (
              <div className={styles.stat}>
                <div className={styles.statBig}>{block.statBig}</div>
                <div className={styles.statLabel}>{block.statLabel}</div>
              </div>
            )}
          </div>
        )}
        <div className={styles.copy}>
          {block.eyebrow && (
            <span className={styles.eyebrow}>{block.eyebrow}</span>
          )}
          {block.heading && <h2 className={styles.heading}>{block.heading}</h2>}
          {block.text && (
            <div
              className={styles.text}
              dangerouslySetInnerHTML={{ __html: sanitizeHtml(block.text) }}
            />
          )}
          {bullets.length > 0 && (
            <ul className={styles.microList}>
              {bullets.map((point, i) => (
                <li key={i}>
                  <BulletCheck />
                  <span>{point}</span>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </section>
  );
};

export default FeatureDeepDiveSection;
